























import BackLink from "@/components/app/BackLink.vue";
import { StatementVue } from "fs-pb-vue2/vueModels/history/StatementVue";
import StatementList from "@/components/history/StatementList.vue";
import { Component } from "vue-property-decorator";
import { StatementModel } from "fs-pb-vue2/models/statement/statementModel";
import { CatalogStore } from "fs-pb-vue2/store/modules/catalog";
import { getModule } from "vuex-module-decorators";

@Component({
  components: { StatementList, BackLink }
})
export default class CostAnalyz extends StatementVue {

  /**Стор каталога */
  get catalogStore(): CatalogStore {
    return getModule(CatalogStore, this.$store);
  }

  get model(): StatementModel {
    return this.catalogStore.operationsHistory;
  }

  get isModal(): boolean {
    return this.$route.query.operInfo && this.$route.query.operInfo.length > 0;
  }
}
